import React from 'react';

import ProjectsDetailPage from './ProjectsDetailPage';

const ProjectsDetailPageWrapper: React.FC = () => <ProjectsDetailPage />;

export default ProjectsDetailPageWrapper;
